import React, { useState } from "react";
import { Button, Form, Input, Select } from "antd";
import { instance } from "utils/axios";

export default function SurgeryFields({
  form,
  types = [],
  doctors = [],
  handleDelete,
}) {
  const [loading, setLoading] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);

  // РД өөрчлөгдөхөд 10 тэмдэгт болсон үед хайна
  const handleRegChange = (e) => {
    const val = e?.target?.value?.trim() || "";
    form.setFieldValue("regno", val);

    if (val.length === 10) {
      getCustomerInfo(val);
    } else {
      // талбаруудыг цэвэрлэнэ (root-level)
      form.setFieldsValue({
        customerId: null,
        lastname: null,
        firstname: null,
        age: null,
        gender: null,
        phone: null,
      });
      setIsNotFound(false);
    }
  };

  const deriveAgeGenderFromReg = (regno) => {
    if (!regno || regno.length !== 10) return {};
    const digits = regno.substring(2);
    if (!/^\d{8}$/.test(digits)) return {};
    const yy = parseInt(digits.substring(0, 2), 10);
    const birthYear = !Number.isNaN(yy)
      ? yy < 30
        ? 2000 + yy
        : 1900 + yy
      : null;
    const age = birthYear ? new Date().getFullYear() - birthYear : null;
    const gDigit = parseInt(digits[6], 10);
    const gender = Number.isFinite(gDigit)
      ? gDigit % 2 === 1
        ? "Эр"
        : "Эм"
      : null;
    return { age, gender };
  };

  const getCustomerInfo = (reg) => {
    setLoading(true);
    instance({ method: "get", url: `customer/find/${reg}` })
      .then((res) => {
        if (res?.data) {
          setIsNotFound(false);
          const { age: dAge, gender: dGender } = deriveAgeGenderFromReg(reg);

          form.setFieldsValue({
            customerId: res.data.id ?? null,
            regno: res.data.regno ?? reg,
            lastname: res.data.lastname ?? null,
            firstname: res.data.firstname ?? null,
            age: res.data.age ?? dAge ?? null,
            gender:
              typeof res.data.gender === "string"
                ? res.data.gender
                : dGender ?? null,
            phone: res.data.phone ?? res.data.mobile ?? null,
          });
        } else {
          // олдсонгүй -> шинээр бүртгэнэ
          form.setFieldValue("customerId", 0);

          const { age, gender } = deriveAgeGenderFromReg(
            (form.getFieldValue("regno") || "").toString()
          );

          form.setFieldsValue({
            lastname: null,
            firstname: null,
            age: age ?? null,
            gender: gender ?? null,
            phone: null,
          });

          setIsNotFound(true);
        }
      })
      .catch(() => {
        form.setFieldValue("customerId", 0);

        const { age, gender } = deriveAgeGenderFromReg(
          (form.getFieldValue("regno") || "").toString()
        );

        form.setFieldsValue({
          lastname: null,
          firstname: null,
          age: age ?? null,
          gender: gender ?? null,
          phone: null,
        });

        setIsNotFound(true);
      })
      .finally(() => setLoading(false));
  };

  // ------- Dynamic form fields (root-level names) -------
  return [
    {
      label: "Регистер",
      name: "regno",
      rules: [
        {
          required: true,
          message: "Үйлчлүүлэгчийн регистрийн дугаар оруулна уу!",
        },
      ],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        maxLength: 10,
        onChange: handleRegChange,
        placeholder: "AA###### (10 тэмдэгт)",
      },
    },
    {
      label: "Овог",
      name: "lastname",
      rules: [{ required: true, message: "Овог оруулна уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Нэр",
      name: "firstname",
      rules: [{ required: true, message: "Нэр оруулна уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Нас",
      name: "age",
      type: "number",
      className: "col-span-6 md:col-span-6 mb-0",
      inputProps: { className: "w-full", min: 0 },
    },
    {
      label: "Хүйс",
      name: "gender",
      type: "select",
      rules: [{ required: true, message: "Хүйс сонгоно уу!" }],
      className: "col-span-6 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        optionFilterProp: "label",
        options: [
          { label: "Эр", value: "Эр" },
          { label: "Эм", value: "Эм" },
        ],
      },
    },
    {
      label: "Тасаг",
      name: "typeId",
      type: "select",
      rules: [{ required: true, message: "Төрөл сонгоно уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full", options: types },
    },
    {
      label: "Огноо",
      name: "surgeryDate",
      type: "date",
      disabled: true,
      rules: [{ required: true, message: "Огноо сонгоно уу!" }],
      className: "col-span-6 md:col-span-2 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Эхлэх цаг",
      name: "startTime",
      type: "time",
      minuteStep: 10,
      className: "col-span-3 md:col-span-2 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Дуусах цаг",
      name: "endTime",
      type: "time",
      minuteStep: 10,
      className: "col-span-3 md:col-span-2 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Утас",
      name: "phone",
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Онош",
      name: "diagnose",
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Ажиллагаа",
      name: "operation",
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full" },
    },
    {
      label: "Эмч",
      name: "doctorIds",
      type: "select",
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        optionFilterProp: "label",
        mode: "multiple",
        options: doctors,
      },
    },
    {
      label: "Төлөв",
      name: "status",
      type: "select",
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        optionFilterProp: "label",
        options: [
          { label: "Төлөвлөсөн", value: "Төлөвлөсөн" },
          { label: "Орсон", value: "Орсон" },
        ],
      },
    },
    {
      label: "Дэлгэрэнгүй мэдээлэл",
      name: "description",
      type: "textarea",
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: { className: "w-full" },
    },
  ];
}
